<div class="popup-container p-3">
  <h2 class="message">
    {{message|translate}}
  </h2>
  <div class="d-flex w-100 justify-content-center">
    <button (click)="dialogRef.close()" class="btn-primary-yes" [routerLink]="'/secure/login'"  mat-raised-button>{{'Login'|translate}}</button>
    <button (click)="dialogRef.close()" class="btn-secondary-no" mat-raised-button routerLink="/secure/register">{{'Register'|translate}}</button>
  </div>
</div>
